import type { Channel } from 'stream-chat';
import { AccessRule, ROLE_NOTIFICATION_RULES } from '@features/components/Chat/constants';
import { StreamUserRole } from '@features/components/Chat/types';
import { StreamChannelType } from '@/api/apis/chat';

const isUserAssignedToChat = (userId: string, channel: Channel): boolean => {
  const member = channel?.state?.members?.[userId];
  return !!member?.is_case_assigned;
};

export const hasUserAccessToChat = (userId: string, role?: string, channel?: Channel): boolean => {
  if (!role || !channel) return false;

  const typedRole = role as StreamUserRole;
  const channelType = (channel.type ?? channel.data?.type) as StreamChannelType;

  if (!channelType) return false;

  const rules = ROLE_NOTIFICATION_RULES[typedRole];
  const rule = rules?.[channelType] ?? AccessRule.None;

  switch (rule) {
    case AccessRule.All:
      return true;
    case AccessRule.Assigned:
      return isUserAssignedToChat(userId, channel);
    case AccessRule.None:
    default:
      return false;
  }
};
